import moment from "moment";
import { api } from "../../api";

export const getCache = async (eventID) => {
  const { data } = await api
    .post(
      "quiz/cache",
      JSON.stringify({
        event_id: eventID,
      })
    )
    .catch((error) => error.response);

  return data;
};

export const updateCache = async (quiz, eventID) => {
  await api
    .put(
      "quiz/cache",
      JSON.stringify({
        event_id: eventID,
        quiz: quiz.quiz,
      })
    )
    .catch((error) => error.response);
};

export const loadQuiz = async (
  quiz,
  setQuiz,
  eventID,
  questionform_id,
  setTimmer,
  handleEndTime,
  state
) => {
  const { data } = await api
    .get(`getquestion/${questionform_id}/${eventID}`)
    .catch((error) => error.response);

  if (data?.payload?.quesion?.length > 0) {
    const { qgroupDes, qgroupName, section, qgroupId } =
      data.payload.quesion[0];
    const { startdate_at, enddate_at, balanceTime, user_id } =
      data.payload.userTime;
    setTimmer({
      startdate_at,
      enddate_at,
      balanceTime,
      user_id,
    });

    const endDate = moment().isAfter(moment(enddate_at));
    if (endDate) {
      handleEndTime();
    } else {
      const examp = section.map((v, k) => ({
        ...v,
        partno: k + 1,
        question: v.question.map((q, k) => ({
          ...q,
          no: k + 1,
          value: "",
        })),
      }));

      const quizData = await getCache(eventID);

      // const _quiz = window.localStorage.getItem("_quiz");
      if (quizData.result) {
        // const beforeQuiz = JSON.parse(_quiz);
        // if (
        //   +beforeQuiz.qgroupId === +qgroupId &&
        //   +beforeQuiz.eventId === +eventID &&
        //   +beforeQuiz.user_id === user_id
        // ) {
        const { page, section, qgroupId } = quizData.payload;
        setQuiz({
          ...quiz,
          page: page || 1,
          qgroupId,
          des: qgroupDes,
          name: qgroupName,
          quiz: section,
          open: false,
        });

        window.localStorage.setItem(
          "_quiz",
          JSON.stringify({
            section,
            qgroupId,
            eventId: +eventID,
            page,
            user_id,
          })
        );
      } else {
        updateCache(
          {
            quiz: { section: examp, page: quiz.page, qgroupId },
          },
          +eventID
        );

        window.localStorage.setItem(
          "_quiz",
          JSON.stringify({
            section: examp,
            qgroupId,
            eventId: +eventID,
            page: quiz.page,
            user_id,
          })
        );
        setQuiz({
          ...quiz,
          qgroupId,
          des: qgroupDes,
          name: qgroupName,
          quiz: examp,
          open: false,
        });

        // window.localStorage.setItem(
        //   "_quiz",
        //   JSON.stringify({
        //     section: examp,
        //     qgroupId,
        //     eventId: +eventID,
        //     page: quiz.page,
        //     user_id,
        //   })
        // );
        // setQuiz({
        //   ...quiz,
        //   qgroupId,
        //   des: qgroupDes,
        //   name: qgroupName,
        //   quiz: examp,
        //   open: false,
        // });
      }
    }

    // state
  } else {
    window.location.href = "/process";
    // if (!data.auth) {
    //   window.location.href = "/login/" + eventID;
    // } else {
    //   setQuiz({
    //     ...quiz,
    //     open: false,
    //     alert: true,
    //     errorText: { error: "เกิดข้อผิดพลาดกรุณาติดต่อเจ้าหน้าที่" },
    //   });
    // }
  }
};

export const saveResult = async (
  answer,
  assetId,
  questionId,
  navigate,
  quiz,
  setQuiz
) => {
  const { data } = await api
    .post(
      "result",
      JSON.stringify({
        quiz: answer,
        assetId,
        questionId,
      })
    )
    .catch((error) => error.response);

  if (data.result) {
    navigate(`/quiz/${assetId}/complete`);
    window.localStorage.removeItem("_quiz");
  } else {
    window.localStorage.removeItem("_quiz");
    setQuiz({
      ...quiz,
      end: true,
      open: false,
      alertTitle: "แจ้งเตือน",
      errorText: { error: data.message || data.error.message },
      alert: true,
    });
    navigate(`/quiz/${assetId}/complete`);
  }
};
